<template>
    <div class="container mt-4">
        <div v-if="loading">
            <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/placeholder_info.svg" alt="">
        </div>
        <div v-if="localPartnerDetails && !loading" class="info-tab">
            <!-- Information -->
            <div v-if="localPartnerDetails.information" class="pb-4">
                <span>
                    {{ showMore ? localPartnerDetails.information : truncatedText() }}
                    <button
                        v-if="localPartnerDetails.information.length > 500"
                        class="border-0 font-weight-bold p-0 text-primary show-more-button bg-transparent"
                        @click="toggleShowMore"
                    >
                    {{ showMore ? $t('Partners.less') : $t('Partners.more') }}
                    </button>
                </span>
            </div>
            <!-- Gallery -->
             <div v-if="localPartnerDetails && localPartnerDetails.gallery && localPartnerDetails.gallery.length" class="py-4">
                <div class="splide platformPartnersSlider partner-splide" :class="randomId" aria-label="partner gallery slider">
                    <div class="splide__track">
                        <ul class="splide__list">
                            <li
                            v-for="(singleSlide, i) in localPartnerDetails.gallery.slice(0, 20)"
                            :key="i"
                            class="splide__slide"
                            :data-splide-youtube="singleSlide.type === 'VIDEO' && singleSlide.videoType === 'YOUTUBE' ? singleSlide.safeVideoUrl : null"
                            :data-splide-vimeo="singleSlide.type === 'VIDEO' && singleSlide.videoType === 'VIMEO' ? singleSlide.videoUrl : null"
                            >
                                <!-- Video Slide (YouTube) -->
                                <template v-if="singleSlide.type === 'VIDEO' && singleSlide.safeVideoUrl">
                                <div class="splide__slide__container rounded-corners-10">
                                    <img v-if="singleSlide.videoImage" :src="singleSlide.videoImage" alt="" />
                                    <img
                                    v-else-if="!singleSlide.videoImage && localPartnerDetails.logo?.xxx"
                                    class="splide-image rounded-corners-10"
                                    :src="localPartnerDetails.logo.xxx"
                                    alt=""
                                    />
                                </div>
                                <div>
                                    <p class="m-0 mt-2 text-black-50" v-if="singleSlide.caption">
                                    {{singleSlide.caption}}
                                    </p>
                                </div>
                                </template>

                                <!-- Image Slide -->
                                <template v-else-if="singleSlide.type === 'IMAGE' && singleSlide.image?.xxx">
                                <div class="splide__slide__container rounded-corners-10">
                                    <img class="splide-image rounded-corners-10" :src="singleSlide.image.xxx" alt="" />
                                </div>
                                <p class="m-0 mt-2 text-black-50" v-if="singleSlide.caption">
                                    {{ singleSlide.caption }}
                                </p>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
             </div>
            <!-- Documents and links-->
            <div v-if="localPartnerDetails && localPartnerDetails.references && localPartnerDetails.references.length"> 
                <h2 class="h4 font-weight-bold py-4">{{ $t('Partners.documentsAndLinks') }}</h2> 
                <div class="pb-4">
                    <div v-for="(documentsInfo, index) in localPartnerDetails.references" :key="index"
                class="bg-white rounded-corners-10 shadow p-3 my-2">
                    <div v-if="documentsInfo.type && documentsInfo.title">
                        <div class="row">
                            <div class="col-auto align-self-center">
                                <a v-if="documentsInfo.url && documentsInfo.url.length && documentsInfo.type === 'LINK'" :href="documentsInfo.url" target="_blank" :aria-label="documentsInfo.title">
                                    <img class="pr-2" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/link_22dp_000000_FILL0_wght400_GRAD0_opsz24.svg" :alt="documentsInfo.title" aria-hidden="true">
                                </a>
                                <a v-if="documentsInfo.resource && documentsInfo.resource.url && documentsInfo.resource.url.length && (documentsInfo.type === 'PDF' || documentsInfo.type === 'ZIP')" :aria-label="documentsInfo.title" :href="documentsInfo.resource.url" target="_blank">
                                    <img class="pr-2" src="/wp-content/themes/understrap-child/reader-web-app-angular/assets/images/documents-partners-icon.svg" :alt="documentsInfo.title" aria-hidden="true">
                                </a>
                            </div>
                            <div class="col px-0">
                                <a v-if="documentsInfo.url && documentsInfo.type === 'LINK'" :href="documentsInfo.url"  target="_blank">
                                    <p v-if="documentsInfo.title" class="mb-0 text-dark font-weight-bold">{{ documentsInfo.title }}</p>
                                </a>
                                <a v-if="documentsInfo.resource && documentsInfo.resource.url && documentsInfo.resource.url.length && (documentsInfo.type === 'PDF' || documentsInfo.type === 'ZIP')" :href="documentsInfo.resource.url"  target="_blank">
                                    <p v-if="documentsInfo.title" class="mb-0 text-dark font-weight-bold">{{ documentsInfo.title }}</p>
                                </a>
                                <span v-if="documentsInfo.subtitle" class="text-black-50">{{ documentsInfo.subtitle }}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <!-- Social Media -->
            <div v-if="localPartnerDetails && localPartnerDetails.links && localPartnerDetails.links.length" class="pb-4">
                <!-- <h4 class="font-weight-bold py-4">{{ $t('Partners.socialMedia') }}</h4> -->
                <div class="d-flex">
                    <div v-for="(link, index) in localPartnerDetails.links" :key="index" class="mr-2 single-social-media">
                        <div v-if="link && link.type && link.type.icon && link.type.icon.svg && link.urls && link.urls.length">
                            <!-- If only one URL, show a simple link -->
                            <a v-if="link.urls.length === 1" :href="link.urls[0]" target="_blank">
                                <img :src="link.type.icon.svg" style="width: 40px; height: 40px;" :alt="link.type.name">
                            </a>
                            <!-- If multiple URLs, show a Bootstrap dropdown -->
                            <div v-else class="dropdown platform-partners-dropdown">
                                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                    <img :src="link.type.icon.svg" style="width: 40px; height: 40px;">
                                </a>
                                <div class="dropdown-menu p-3">
                                    <a v-for="(url, i) in link.urls" :key="i" class="bg-white d-flex dropdown-item py-2 rounded-corners-10 shadow mb-2" :href="url" target="_blank">
                                        <img v-if="link.type.icon.svg" :src="link.type.icon.svg" style="width: 30px; height: 30px;">
                                        <span v-if="url" class="align-self-center col">{{ url }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import Splide from "@splidejs/splide";
import { Video } from '@splidejs/splide-extension-video';

    export default {
        name: 'InfoTab',
        props: {
            settingsPerm: Object,
            partnerDetails: Object
        },
        data() {
            return {
                loading: true,
                isDevMioActive: this.settingsPerm.isDevMioActive,
                isReadMore: false,
                activateTheinfoToggle: false,
                showMore: false,
                splide: null,
                metaCount: 0,
                randomId: this.generateRandomId(),
                itemFetchCount: 0,
                currentPage: 1,
                localPartnerDetails: { ...this.partnerDetails }
            };              
        },
        async mounted() {
                await this.switchGalleryurls();
        },
        created() {
            if (this.localPartnerDetails) {
                this.truncatedText();
            }
        },
        methods: {
            async switchGalleryurls() {
                if (!this.localPartnerDetails?.gallery?.length) {
                    this.loading = false;
                    return;
                }

                const updatedGallery = await Promise.all(
                    this.localPartnerDetails.gallery.map(async (item) => {
                        if (item.type === 'VIDEO' && item.videoUrl) {
                            let videoId = null;
                            let videoImage = null;
                            let safeVideoUrl = item.videoUrl;

                            // YouTube video check
                            if (item.videoUrl?.includes('youtube.com') || item.videoUrl?.includes('youtu.be')) {
                                videoId = this.extractYouTubeId(item.videoUrl);
                                if (videoId) {
                                    safeVideoUrl = `https://www.youtube.com/watch?v=${videoId}`;
                                    videoImage = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
                                }
                            }
                            // Vimeo video check
                            else if (item.videoUrl?.includes('vimeo.com')) {
                                videoId = this.extractVimeoId(item.videoUrl);
                                if (videoId) {
                                    videoImage = await this.fetchVimeoThumbnail(videoId);
                                }
                            }

                            return { ...item, safeVideoUrl, videoImage };
                        }
                        return item;
                    })
                );

                // Update state
                this.localPartnerDetails = { ...this.localPartnerDetails, gallery: updatedGallery };
                this.loading = false;
                setTimeout(() => {
                    this.mount_splide();
                }, 300);
            },

            getTruncatedText(text, maxLength) {
                return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
            },

            extractYouTubeId(url) {
                const match = url.match(/(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([^?&]+)/);
                return match ? match[1] : null;
            },

            extractVimeoId(url) {
                const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                return match ? match[1] : null;
            },

            async fetchVimeoThumbnail(videoId) {
                const apiUrl = `https://vimeo.com/api/v2/video/${videoId}.json`;
                try {
                    const response = await fetch(apiUrl);
                    const data = await response.json();
                    return data[0]?.thumbnail_large || null;
                } catch (error) {
                    console.error("Error fetching Vimeo thumbnail:", error);
                    return null;
                }
            },
            
            truncatedText() {
                if (this.localPartnerDetails.information && this.localPartnerDetails.information.length > 500) {
                    return this.localPartnerDetails.information.slice(0, 500) + ' ' + '...';
                }else{
                    return this.localPartnerDetails.information;
                }
            },
            // Method to toggle the "show more" state
            toggleShowMore () {
                this.showMore = !this.showMore;
            },

            generateRandomId() {
                const randomSuffix = Math.random().toString(36).substring(2);
                return 'a' + randomSuffix; 
            },

            mount_splide: function () {
                let thiz = this;
                let arrows = false;
                let sliderPadding = { left: '0px', right: '0rem' };
                if (this.partnerDetails?.gallery?.length > 1) {
                    arrows = true;
                    sliderPadding   = { left: '0px', right: '3rem' };
                }
                setTimeout(function () {
                    if (!thiz.splide) {
                        thiz.splide = new Splide('.'+thiz.randomId, {
                            rewind: false,
                            arrows: arrows,
                            perPage: 1,
                            heightRatio: 0.5625,
                            perMove: 1,
                            gap: '1rem',
                            start: 0,
                            pagination: false,
                            padding: sliderPadding,
                            rewindByDrag: true,
                            cover: true,
                            video: {
                            loop: true,
                            },
                            breakpoints: {
                                575: {
                                    heightRatio: 0.6625,
                                },
                            },
                        });
                        // if last slide remove padding
                  
                        thiz.splide.mount({ Video });
                    } else {
                    //thiz.splide.refresh(); // Refresh the existing Splide instance
                }
            }, 100);
            },
        },
    }
    
</script>

<style>
    .partner-splide .splide__slide img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
    .show-more-button:focus {
        outline: none !important;
    }

    .headerVideo {
        height: 438px;
        max-height: 438px;
    }
    
    .splide__arrow:focus-visible {
        outline: none !important;
        outline-offset: 0px;
    }

    .splide__arrow:disabled {
        opacity: 0.3 !important;
    }
    
    .platformPartnersSlider .splide__arrow:disabled, .newFourFeatureSlider .splide__arrow:disabled {
        opacity: 0.3 !important;
    }

    .platform-partners-dropdown a.dropdown-toggle::after {
        display: none !important;
    }
    .platform-partners-dropdown .dropdown-menu{
        position: absolute;
        top: 13px !important;
    }
    /* media queries */
    @media screen and (max-width: 992px) {
        .headerVideo {
            height: 300px;
            max-height: 300px;
        }
        .prev {
            top: 40% !important;
            left: 80% !important;
        }
        .next {
            top: 40% !important;
        }
    }
    @media screen and (min-width: 575px) {
        .prev {
            left: -2rem !important;
            background-color: transparent !important;
            outline: none !important;
        }

        .next {
            right: -2rem !important;
            background-color: transparent !important;
            outline: none !important;
        }

        .arrows {
            position: static !important;
        }
    }   
</style>
    